import { Injectable } from '@angular/core';
import { AppDataService } from './services/app-data.service';
import { ThemeService } from './services/theme.service';
import { BehaviorSubject } from 'rxjs';
import { AuthenticationService } from './services/authentication.service';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  public sytstemSettingData = new BehaviorSubject<any>({});
  public logoUrl = new BehaviorSubject<any>(undefined);
  canShowMenu = false;

  constructor(
    private dataService: AppDataService,
    private themeService: ThemeService,
    private authService: AuthenticationService,
    private router: Router,
    private storage: Storage,
  ) { }

  async initAppData() {
    const tempSystemSettingData = await this.dataService.getData(
      'system_settings'
    );
    this.sytstemSettingData.next(JSON.parse(JSON.stringify(tempSystemSettingData)).data[0]);
    if (this.systemSettings?.login_on_start) {
      // Init and Get Local Storage data
      this.authService.getLocalStorage();
    } else {
      var creds = await this.storage.get('creds');
      if (creds) {
        this.authService.getLocalStorage();
      } else {
        if (this.systemSettings.homepage) {
          // console.log('home')
          this.router.navigate([this.systemSettings.homepage])
        } else {
          this.router.navigate(['login'])
        }
      }
    }
    this.themeService.setTheme(this.systemSettings.theme_color);
  }

  get systemSettings() {
    return this.sytstemSettingData.getValue();
  }

  // canShowSideMenu() {
  //   this.canShowMenu = this.systemSettings.login_on_start
  //     ? this.authService?.isLoggedIn
  //     : true;
  // }
}
